import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import LiveAggregateRatingSchema from "./LiveAggregateRatingSchema";

const Layout = ({ children }) => {
  // Embed mode — used by the partner-clinic widget snippet. Strips the
  // Navbar / Footer / floating actions so the tool renders naked inside
  // an iframe on a third-party site.
  const { search } = useLocation();
  const isEmbed = new URLSearchParams(search).get("embed") === "1";

  if (isEmbed) {
    return (
      <div className="min-h-screen bg-background text-foreground">
        <main id="main-content" className="flex-1" tabIndex={-1}>{children}</main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[hsl(var(--primary))] focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-[hsl(var(--accent))]"
        data-testid="skip-to-main"
      >
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" className="flex-1" tabIndex={-1}>{children}</main>
      <Footer />
      <FloatingActions />
      <LiveAggregateRatingSchema />
    </div>
  );
};

export default Layout;
